<template>
  <div class="person">
    <el-form
      :inline="true"
      label-position="left"
      class="demo-form-inline"
      :model="form"
    >
      <el-form-item label="">
        <el-select
          filterable
          placeholder="点位类型"
          clearable
          style="width: 120px;"
          v-model="form.pointTypes"
        >
          <el-option
            v-for="item in pointTypeOptions"
            :key="item.id"
            :label="item.typeName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select
          filterable
          placeholder="所属社区"
          clearable
          style="width: 144px;"
          v-model="communityCode"
          @change="commcommunityChange"
        >
          <el-option
            v-for="item in commcommunityList"
            :key="item.id"
            :label="item.pointName"
            :value="item.id + '-' + item.pointName"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select
          filterable
          placeholder="所属网格"
          clearable
          style="width: 144px;"
          v-model="form.levelName3"
        >
          <el-option
            v-for="item in blockList"
            :key="item.id"
            :label="item.pointName"
            :value="item.pointName"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-input
          v-model="form.sxmc"
          clearable
          placeholder="请输入事项名称"
          style="width:190px;"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input
          v-model="form.pointName"
          clearable
          placeholder="请输入点位名称"
          style="width:228px;"
        >
          <el-button
            style=" background: #0495FF;
                          border-radius: 0px 4px 4px 0px;
                          color: #FFFFFF;"
            slot="append"
            icon="el-icon-search"
            @click="onSearch"
          ></el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <common-table
      :isShowPagination="false"
      :select="false"
      :dataList="dataList"
      :maxHeight="400"
    >
      <template v-slot:pointTypes="{ scope }">
        <span>{{ getPointTypeName(scope.row.pointTypes) }}</span>
      </template>
      <template v-slot:operation="{ scope }">
        <el-button
          @click="openDialog(scope.row, scope.$index)"
          style="color: #0090FF;font-size: 16px;"
          type="text"
          >{{ scope.row.userName ? "重新选择" : "选择责任人" }}</el-button
        >
      </template>
    </common-table>
    <personDialog
      v-if="dialogVisible"
      :dialogVisible.sync="dialogVisible"
      :pointId="pointId"
      @updateData="updateData"
    ></personDialog>
  </div>
</template>

<script>
import commonTable from "@/components/table/index.vue";
import personDialog from "./personDialog";
import index from "@/mixins/index.js";
export default {
  components: {
    commonTable,
    personDialog
  },
  props: {
    personList: {
      type: Array,
      default: []
    }
  },
  mixins: [index],
  data() {
    return {
      form: {
        pointTypes: "",
        communityCode: "",
        levelName3: "",
        sxmc: "",
        pointName: ""
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "pointName",
            label: "点位名称"
          },
          {
            slot: "pointTypes",
            label: "点位类型"
          },
          {
            prop: "levelName2",
            label: "所属社区"
          },
          {
            prop: "levelName3",
            label: "所属网格"
          },
          {
            prop: "sxmc",
            label: "事项名称"
          },
          {
            prop: "userName",
            label: "责任人"
          },
          {
            slot: "operation",
            label: "操作"
          }
        ]
      },
      dialogVisible: false,
      pointId: "",
      curIndex: 0,
      personListAll: []
    };
  },
  mounted() {
    this.getCommcommunityAllFun();
    this.getPointTypeListPageFun();
    this.dataList.tableData = this.personList;
    this.personListAll = this.personList;
  },
  methods: {
    nextStepsFun() {
      this.$emit("updatePerson", this.personListAll);
    },
    onSearch() {
      this.dataList.tableData = this.personList;
      if (this.form.pointTypes)
        this.dataList.tableData = this.dataList.tableData.filter(
          item => item.pointTypes == this.form.pointTypes
        );
      if (this.form.communityCode)
        this.dataList.tableData = this.dataList.tableData.filter(
          item =>
            item.levelName2 &&
            item.levelName2.indexOf(this.form.communityCode) > -1
        );
      if (this.form.sxmc)
        this.dataList.tableData = this.dataList.tableData.filter(
          item => item.sxmc && item.sxmc.indexOf(this.form.sxmc) > -1
        );
      if (this.form.levelName3)
        this.dataList.tableData = this.dataList.tableData.filter(
          item =>
            item.levelName3 &&
            item.levelName3.indexOf(this.form.levelName3) > -1
        );
      if (this.form.pointName)
        this.dataList.tableData = this.dataList.tableData.filter(
          item =>
            item.pointName && item.pointName.indexOf(this.form.pointName) > -1
        );
    },
    updateData(item) {
      this.dataList.tableData[this.curIndex].userId = item.userId;
      this.dataList.tableData[this.curIndex].userName = item.userName;
      this.personListAll = this.dataList.tableData;
    },
    openDialog(item, index) {
      console.log(item);
      this.pointId = item.pointLevelId;
      this.curIndex = index;
      this.dialogVisible = true;
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
@import "~@/components/less.less";
.person {
  height: 100%;
  width: 100%;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/pages/task/longInspectionTask/components/person.vue